module.exports = __webpack_public_path__ + "img/hongtouwenjian2.bfbb3d25.png";